import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IDepartment } from '../models/department';
import { EEopTemplates } from '../models/eop_types.enum';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
    constructor(private http: HttpClient) {}

    getDepartments(eopTemplateId: EEopTemplates, orgType?: string): Observable<{has_error: boolean, message: string, data: IDepartment[]}> {
      const url = environment.apiBaseUrl + endpoints.departments.replace(':eopTemplateId', eopTemplateId.toString());
      let params = new HttpParams();
      if (orgType) {
        params = params.set('org_type', orgType);
      }
      
      return this.http.get<{has_error: boolean, message: string, data: IDepartment[]}>(url, { params }).pipe(
        catchError(this.handleError) 
      );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
      let errorMessage = 'An unknown error occurred!';
      
      if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
      }
      console.error(errorMessage);
      return throwError(() => new Error("Cannot retrieve data from server. Please try again."));
    }

    

}